import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './ActiveLink.scss';

class ActiveLink extends Component {
  constructor(props) {
    super(props);
    const isActive = this.checkIfActive(this.props.location.pathname, this.props.url);

    this.state = {
      isActive: isActive,
    };
  }

  checkIfActive = (currentPath, targetUrl) => targetUrl === currentPath;

  render() {
    const props = this.props;
    const isActive = this.state.isActive;
    return (
      <a
        href={props.url}
        className={cx('link', {
          [props.className]: props.className,
          [props.activeClassName || 'link--active']: isActive
        })}
        target={props.target}
        rel={props.rel}>
        {props.children}
      </a>
    );
  }
}

ActiveLink.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  target: PropTypes.string,
  rel: PropTypes.string,
  className: PropTypes.string,
  activeClassName: PropTypes.string,
};

export default ActiveLink;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ActiveLink/ActiveLink.js